import { call, all } from 'redux-saga/effects';
import {watchGetDataMain, watchSetDataMain,watchGetDataKHName,watchDeleteTemplate} from "./mainSaga";
import {watchGetDataEmail, watchGetDataNew, watchSetDataNew} from "./newSaga";
import {watchGetDataPlanConfigByStep, watchSetDataPlanConfigByStep} from "./planConfigByStepSaga";
//IndexImportHygen

export default function* rootPlanTemplateSaga() {
  yield all([
    call(watchGetDataMain),
    call(watchGetDataKHName),
    call(watchSetDataMain),
    call(watchGetDataNew),
    call(watchSetDataNew),
    call(watchGetDataPlanConfigByStep),
    call(watchSetDataPlanConfigByStep),
    call(watchDeleteTemplate),
    call(watchGetDataEmail)
    //IndexUsingHygen
    ])
}